module.exports = __webpack_public_path__ + "img/fotografia_poster.dfc91a0d.jpg";